import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const TotalPayoutSkeleton = () => {
  return (
    <div className="flex flex-col flex-1 gap-14 overflow-hidden h-fit">
      <Card className="bg-white border-0 shadow-lg rounded-2xl xl:rounded-3xl overflow-hidden h-fit gap-0">
        <CardHeader className="px-8 py-6">
          <div className="flex items-center justify-between">
            <CardTitle className="text-[32px] font-medium">
              Your Total Payout
            </CardTitle>
            <Skeleton className="h-9 w-24 rounded-full" />
          </div>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <div className="flex flex-col xl:flex-row items-center justify-between h-fit">
            <div className="flex justify-center text-center w-full h-full items-center">
              <Skeleton className="h-16 w-48 my-4" />
            </div>
            <div className="flex w-full flex-col gap-4">
              <div className="bg-cyan-50 rounded-2xl py-4 text-center min-w-[15dvw]">
                <Skeleton className="h-8 w-24 mx-auto mb-1" />
                <div className="text-gray-600 text-sm">Per 100 Miles</div>
              </div>
              <div className="bg-cyan-50 rounded-2xl px-6 py-4 text-center min-w-[15dvw]">
                <Skeleton className="h-8 w-24 mx-auto mb-1" />
                <div className="text-gray-600 text-sm">Total Miles</div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-12 w-24 rounded-md" />
              <div className="flex flex-col">
                <Skeleton className="h-5 w-32 mb-2" />
                <Skeleton className="h-4 w-48" />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <div className="flex items-center justify-center gap-12 text-nowrap flex-wrap">
        <Skeleton className="h-6 w-36" />
        <Skeleton className="h-6 w-36" />
        <Skeleton className="h-6 w-36" />
      </div>
    </div>
  );
};
